import { ResizablePanel } from '@art-of-hospitality-solutions-llc/ui-kit/components/resizable';

export default function PreviewContainer({
  children,
  topBar,
}: {
  children: React.ReactNode;
  /** Mode bar pinned to the top of the pane (e.g. "Add a section"). */
  topBar?: React.ReactNode;
}) {
  return (
    <ResizablePanel minSize={30} className="min-w-0">
      {/* Centering uses mx-auto on the inner wrapper rather than
          justify-center: a centered flex child that overflows spills past
          the reachable scroll area on the left, while auto margins collapse
          to 0 on overflow so both edges stay scrollable. Padding lives on
          the wrapper so the right/bottom gutter scrolls with the content
          instead of being clipped. */}
      <div className="h-full min-w-0 overflow-auto bg-gray-100">
        {topBar && <div className="sticky top-0 z-30 px-4 pt-4">{topBar}</div>}
        <div className="mx-auto w-fit p-4">{children}</div>
      </div>
    </ResizablePanel>
  );
}
